function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  left: 50%;\n  width: 3.6875em;\n  height: 3.6875em;\n  margin: -1.84375em;\n  background: ", ";\n  border-radius: 50%;\n  box-shadow: -2.1875em 0.6875em 0 -0.6875em ", ",\n    2.0625em 0.9375em 0 -0.9375em ", ",\n    0 0 0 0.375em ", ",\n    -2.1875em 0.6875em 0 -0.3125em ", ",\n    2.0625em 0.9375em 0 -0.5625em ", ";\n\n  &:after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: -0.5em;\n    display: block;\n    width: 4.5625em;\n    height: 1em;\n    background: ", ";\n    box-shadow: 0 0.4375em 0 -0.0625em ", ";\n  }\n\n  &:nth-child(2) {\n    z-index: 0;\n    background: ", ";\n    box-shadow: -2.1875em 0.6875em 0 -0.6875em ", ",\n      2.0625em 0.9375em 0 -0.9375em ", ",\n      0 0 0 0.375em ", ",\n      -2.1875em 0.6875em 0 -0.3125em ", ",\n      2.0625em 0.9375em 0 -0.5625em ", ";\n    opacity: 0.6;\n    transform: scale(0.5) translate(6em, -3em);\n    animation: ", " 4s linear infinite;\n  }\n\n  &:nth-child(2):after {\n    background: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
import Pan from './animations/Pan';
import { ThemePropType, defaultTheme } from '../constants';
var Cloud = styled.div.attrs({
  'data-e2e': 'cloud',
  'data-animation': true
})(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.backgroundColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.backgroundColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.backgroundColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.cloudsColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.cloudsColor;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.cloudsColor;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.backgroundColor;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.cloudsColor;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.cloudsColor;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.cloudsColor;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.cloudsColor;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.cloudsColor;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.cloudsColor;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.cloudsColor;
}, Pan, function (_ref15) {
  var theme = _ref15.theme;
  return theme.cloudsColor;
});
Cloud.displayName = 'Cloud';
Cloud.propTypes = {
  theme: ThemePropType
};
Cloud.defaultProps = {
  theme: defaultTheme
};
export default Cloud;